import { render, staticRenderFns } from "./NovaModal.vue?vue&type=template&id=62186bb4&lang=pug&"
import script from "./NovaModal.vue?vue&type=script&lang=js&"
export * from "./NovaModal.vue?vue&type=script&lang=js&"
import style0 from "./NovaModal.vue?vue&type=style&index=0&id=62186bb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports